import axios from 'axios'
import { get } from "./AwsRequestService"

const myApi = 'FlightService'

export async function getCancelledFlight(city, date) {
    const getPath = `/api/airports/city/${city}/date/${date}`
    return await get(myApi, getPath);
}